import styles from "./style.module.scss";

import { useEffect, useRef, useState } from "react";
import { useAppDispatch } from "@/store/hooks";
import DynamicForm, { DynamicFormRef, setCurrencySymbolForMoneyInputs } from "@mavichpe/dynamic-forms";
import DocumentPaymentWaysConfig from "./form";
import { EDocumentPaymentWayDataType } from "@/formTypes/EDocumentPaymentWayDataType";
import { CurrencyIdPubSub, CurrencyUpdatePubSubPayload } from "@utils/pubsubs/PubSub";
import { CurrencyApi } from "@/api/CurrencyApi";
import { setCurrency } from "@/store/slices/currencySlides";
import { CURRENCIES_SYMBOLS } from "@utils/Constants";
import { removeFunctionFromObject } from "@utils/Utils";

type DocumentPaymentWaysFormProps = {
  onPaymentWayAdded?: (data: EDocumentPaymentWayDataType) => void,
  innerForm?: boolean
}

const DocumentPaymentWaysForm = (props: DocumentPaymentWaysFormProps) => {
  const dispatch = useAppDispatch()
  const { onPaymentWayAdded, innerForm = false } = props;
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const formRef = useRef<DynamicFormRef>(null);
  const defaultData = {
    forma_pago: 1
  }

  const onSubmit = (formData: EDocumentPaymentWayDataType) => {
    if (onPaymentWayAdded) {
      onPaymentWayAdded(formData)
    }
    formRef.current?.resetFormValue(defaultData)
  }

  useEffect(() => {
    const unsubscribe = CurrencyIdPubSub.subscribe(setFormCurrency);
    return () => {
      unsubscribe();
    };
  }, []);

  const setFormCurrency = async (payload: CurrencyUpdatePubSubPayload) => {
    const { currencyId, forceUpload = true } = payload;
    const priceData = await CurrencyApi.get(currencyId);
    if (priceData.currency_id) {
      dispatch(setCurrency(removeFunctionFromObject(priceData)));

      setCurrencySymbol(CURRENCIES_SYMBOLS[priceData.currency_id])
      if (formRef) {
        const currentFormData = await formRef.current?.getFormData(false);
        if (forceUpload || !currentFormData.exchange_rate) {
          formRef.current?.setFormValue("exchange_rate", priceData.exchange_rate, "decimal")
        }
      }
    }
  }

  const getFormConfig = () => {
    let config = {
      ...DocumentPaymentWaysConfig
    }

    if (currencySymbol) {
      config = setCurrencySymbolForMoneyInputs(DocumentPaymentWaysConfig, currencySymbol)
    }
    return config
  }

  const onInputKeyDown = async (name: keyof EDocumentPaymentWayDataType, event?: React.KeyboardEvent<any>) => {
    if (event?.key == "Enter") {
      const formData = await formRef.current?.getFormData()
      if (formData) {
        onSubmit(formData)
      }
    }
  }

  return (
    <>
      <DynamicForm<EDocumentPaymentWayDataType>
        ref={formRef}
        autoFocusErrors={false}
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={getFormConfig()}
        onInputKeyDown={onInputKeyDown}
        onSubmit={onSubmit}
      >
      </DynamicForm>
    </>

  )
}

export default DocumentPaymentWaysForm;